import type { LunaMessage } from "services/luna/lunaSocket";
import type { LunaState } from "./luna";

// Pure selectors, kept out of luna.ts so they can be tested without pulling in
// the store's socket/App imports.
//
// zustand v5 hands selector results straight to React.useSyncExternalStore,
// which compares snapshots with Object.is. A selector that builds a fresh
// array or object on every call therefore never settles. v4 hid this behind
// the use-sync-external-store shim; under v5 the fallbacks below must be
// stable identities, and anything derived needs a useShallow wrapper.
export const EMPTY_MESSAGES: LunaMessage[] = [];
export const EMPTY_PAGINATION = { hasMore: false, isLoadingMore: false };

// Derives a new array per call, so its hook must wrap it in useShallow.
export const selectLunaMessages =
  (sessionId: string | null) =>
  (state: LunaState): LunaMessage[] => {
    if (!sessionId) return EMPTY_MESSAGES;
    const messageMap = state.messages[sessionId] || {};
    return Object.values(messageMap).sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
    );
  };

export const selectLunaPagination =
  (sessionId: string | null) => (state: LunaState) =>
    sessionId
      ? state.pagination[sessionId] || EMPTY_PAGINATION
      : EMPTY_PAGINATION;
